"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
/**
 * Add tooltip to provided element.
 *
 * @param {HTMLElement} element Trigger element.
 * @param {object} options Overrides tippy instance options.
 */
async function init(element, options = {}) {
    const triggerElement = element;
    const targetId = triggerElement.getAttribute('data-tooltip-target');
    const triggerMethod = triggerElement.getAttribute('data-tooltip-trigger') || 'click';
    const placement = triggerElement.getAttribute('data-tooltip-placement') || 'auto';
    const theme = triggerElement.getAttribute('data-tooltip-theme') || 'nt';
    const tooltipContent = targetId ? document.getElementById(targetId) : null;
    if (!tooltipContent) {
        return null;
    }
    const { default: tippy, hideAll } = await Promise.resolve().then(() => __importStar(require('tippy.js')));
    const tippyInstance = tippy(triggerElement, {
        content: tooltipContent.innerHTML,
        allowHTML: true,
        placement: placement,
        trigger: triggerMethod === 'hover' ? 'mouseenter focusin' : triggerMethod,
        arrow: true,
        interactive: true,
        theme: theme,
        offset: [0, 20],
        maxWidth: theme === 'light-popover' ? 600 : 350,
        onShow(instance) {
            // Keyboard usage leaves previous tippy open without this
            hideAll({ exclude: instance });
            instance.popper.addEventListener('click', (e) => {
                if (!e.target?.closest('.js-tooltip-close')) {
                    return;
                }
                e.preventDefault();
                instance.hide();
            });
        },
        onShown(instance) {
            // Hide tooltip from close button inside content
            instance.popper.addEventListener('click', (e) => {
                if (!e.target?.closest('.js-tooltip-close')) {
                    return;
                }
                e.preventDefault();
                instance.hide();
            });
        },
        ...options,
    });
    // Disable hover tooltip in mobile, because generally they don't have hovers.
    // Not really good way to check window width, but what can you do.
    if (triggerMethod === 'hover') {
        const breakPoint = window.matchMedia('(max-width:671px)'); //md in css
        const breakpointChecker = function () {
            if (breakPoint.matches === true) {
                tippyInstance.disable();
            }
            else if (breakPoint.matches === false) {
                tippyInstance.enable();
            }
        };
        breakPoint.onchange = (e) => {
            if (e.matches) {
                tippyInstance.disable();
            }
            else {
                tippyInstance.enable();
            }
        };
        breakpointChecker();
    }
    return tippyInstance;
}
exports.init = init;
